import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  token: string | null;
  email: string | null;
  mfaToken: string | null;
  setToken: (token: string, email?: string) => void;
  setMfaToken: (token: string | null) => void;
  clear: () => void;
}

// Token is stored in localStorage for the SPA — admin runs at admin.nutrayan.com.
// httpOnly-cookie auth (per RULES Art 12) is preferred and used by the backend
// for storefront; admin uses a Bearer token so the React SPA can attach it manually.
export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      email: null,
      mfaToken: null,
      setToken: (token, email) => set({ token, email: email ?? null, mfaToken: null }),
      setMfaToken: (mfaToken) => set({ mfaToken }),
      clear: () => set({ token: null, email: null, mfaToken: null }),
    }),
    { name: "ntr_admin_auth", version: 1 },
  ),
);
